import { render, staticRenderFns } from "./errPage.vue?vue&type=template&id=78a91e62"
import script from "./errPage.vue?vue&type=script&lang=js"
export * from "./errPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports